import React from 'react';
import '../NewsLetter/NewsLetter.css';

const NewsLetter = () => {
  return (
    <div className="newsletter">
      <h1>Get Exclusive Offers</h1>
      <p>Subscribe to our newsletter and stay updated</p>

      <div className="newsletter-input">
        <input type="email" placeholder="Enter your email address" />
        <button>Subscribe</button>
      </div>
    </div>
  );
};

export default NewsLetter;
